export default "__VITE_ASSET__B6FdPHsg__"